// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/infomodal/infomodal.component.scss
// module id = 465
// module chunks = 0